<span class="has-dropdown language-selector-dropdown select-holder" (click)="showLanguageDropdownBtnClicked()">
  <select (change)="changeLanguage($event.target)">
    @for (language of languages; track language) {
      <option [selected]="currentLanguage.code === language.code"
        [value]="language.code">
      {{language.title}}</option>
    }
  </select>
</span>
